import React, { useContext } from 'react';
import { ContractStatus, Phase3 } from '@indigo-ag/schema';
import { Body, Theme, TinyBody } from '@indigo-ag/component-module';

import i18next from 'core/i18n';
import { PhaseSection, createStylesHook, phase3FileTypes, utils } from 'shared';
import { DocumentsValidationList } from './DocumentsValidationList/DocumentsValidationList';
import { UserContext } from 'core/components/GateWay/GateWay';
import { DocumentsValidationLuchesiDecisions } from './DocumentsValidationLuchesiDecisions/DocumentsValidationLuchesiDecisions';

const useStyles = createStylesHook<Theme>((theme: Theme) => ({
  card: {
    marginBottom: theme.spacing(3)
  }
}));

interface DocumentsValidationSectionProps {
  phase3Info: Phase3;
}

export const DocumentsValidationSection: React.FunctionComponent<DocumentsValidationSectionProps> = ({
  phase3Info
}) => {
  /**
   * Styles
   */
  const classes = useStyles();

  /**
   * User Context
   */
  const { isLuchesi } = useContext(UserContext);

  const showDocumentsReceivedAtFooter =
    phase3Info.contractStatus === ContractStatus.REVIEWING_SIGNED_DOCUMENTS && !phase3Info.signedDocumentsReviewedBy;

  return (
    <PhaseSection
      title={i18next.t('documentsValidation')}
      updatedBy={
        showDocumentsReceivedAtFooter ? utils.text.firstLetterUppercase(i18next.t('documentsReceivedAt')) : undefined
      }
      updatedAt={showDocumentsReceivedAtFooter ? phase3Info.signedDocumentsReceivedAt : undefined}
      classes={{ card: classes.card }}
    >
      {!!phase3Info?.signedDocumentsReviewNotes?.length &&
      phase3Info.contractStatus === ContractStatus.REVIEWING_SIGNED_DOCUMENTS ? (
        <>
          <TinyBody>{i18next.t('commentsOrRecommendations')}</TinyBody>
          <Body className="mb-3 mt-0">{phase3Info.signedDocumentsReviewNotes}</Body>
        </>
      ) : null}
      <DocumentsValidationList phase3Info={phase3Info} />
      {isLuchesi && phase3Info.contractStatus === ContractStatus.REVIEWING_SIGNED_DOCUMENTS && (
        <DocumentsValidationLuchesiDecisions
          hasDocuments={!!phase3Info.files?.filter(f => phase3FileTypes.includes(f.documentType)).length}
        />
      )}
    </PhaseSection>
  );
};
